import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import trump from '../img/trump.png'
import kamala from '../img/kamala.png'
import Experto from './Experto';
import Informado from './Informado';
import Informate from './Informate';
import logo from '../img/8. Imagotipo-El-Universal-Vertical_Cuadrado_Azul.png'


const Quiz = ({ onQuizComplete }) => {
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [answers, setAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [userId, setUserId] = useState('');
  const navigate = useNavigate();
  useEffect(() => {
    // Comprobamos si ya tenemos un userId almacenado en el localStorage
    const storedUserId = localStorage.getItem('userId');
    if (storedUserId) {
      setUserId(storedUserId);
    } else {
      // Si no hay un userId almacenado, generamos uno nuevo y lo guardamos
      const newUserId = 'user' + Math.floor(Math.random() * 1000000); // Generamos un número aleatorio para el userId
      setUserId(newUserId);
      localStorage.setItem('userId', newUserId);
    }
  
    const storedAnswers = localStorage.getItem('quizAnswers');
    if (storedAnswers) {
      const parsedAnswers = JSON.parse(storedAnswers);
      setAnswers(parsedAnswers);
      const lastQuestion = Object.keys(parsedAnswers).length;
      setCurrentQuestion(lastQuestion + 1);
      setQuizCompleted(lastQuestion >= 10); // Actualiza el estado de quizCompleted según si se han respondido todas las preguntas
      if (lastQuestion >= 10) {
        setShowResults(true); // Muestra los resultados si se han respondido todas las preguntas
      }
    }
  }, []);
  
 
  const handleAnswer = (option) => {
    if (!answers[currentQuestion]) {
      // Obtener el ID de la pregunta actual del estado local
      const questionID = [
        1729031286,
        1729031322,
        1729031351,
        1729031374,
        1729031397,
        1729031424,
        1729031446,
        1729031469,
        1729031572,
        1729031592        
      ][currentQuestion - 1];
  
      // Obtener el target de la opción seleccionada
      const target = option.target.toString();
  
      // Crear el objeto directamente en el cuerpo de la solicitud POST
      const bodyData = JSON.stringify({
        idpregunta: questionID.toString(),
        respuestau: option.text.toString(),
        useranswer: userId
      });
  
      // Actualizar las respuestas en el estado local
      const updatedAnswers = { ...answers, [currentQuestion]: { bodyData, target } };
      setAnswers(updatedAnswers);
      localStorage.setItem("quizAnswers", JSON.stringify(updatedAnswers));
  
      setCurrentQuestion(currentQuestion + 1);
      if (currentQuestion >= 10) {
        setShowResults(true);
        setQuizCompleted(true);
        onQuizComplete();
      }
  
      // Realizar la solicitud POST a la API
      fetch("https://zmp55fgimf.execute-api.us-east-2.amazonaws.com/prod/respuestas", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyData,
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error al enviar el dato: " + response.statusText);
        }
       console.log("¡Petición realizada con éxito!"); 
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    }
  };
  const calculateResult = (answers) => {
    let correctAnswer = 0;
    let totalQuestions = Object.keys(answers).length;
    
    for (const answer of Object.values(answers)) {
      if (answer.target && answer.target.toLowerCase() === "correcta") {
        correctAnswer += 1;
      }
    }
  
    if (correctAnswer >= 8 && correctAnswer <= 10) {
      return <Experto correctAnswer={correctAnswer} totalQuestions={totalQuestions} />;
    } else if (correctAnswer >= 5 && correctAnswer <= 7) {
      return <Informado correctAnswer={correctAnswer} totalQuestions={totalQuestions} />;
    } else if (correctAnswer >= 0 && correctAnswer <= 4) {
      return <Informate correctAnswer={correctAnswer} totalQuestions={totalQuestions} />;
    }
  };
  
  
  
  const renderQuestion = () => {
    const questions = [
      {
        title: "Afirma que EU es un país de migrantes y se requiere de una reforma migratoria que incluya una vía para la legalización, sin descuidar la frontera",
        options: [
          { text: "Trump", image: trump, target: "error", weight: 1 },
          { text: "Harris", image: kamala, target: "correcta", weight: 1 }
        ]
      },
      {
        title: "Dice que EU vive una invasión de personas de otros países: criminales, violadores, por lo que se necesita un muro y expulsar a tantos migrantes como sea posible. Favorece una deportación masiva.",
        
        options: [
          { text: "A) Harris", image: kamala, target: "error", weight: 1 },
          { text: "B) Trump", image: trump, target: "Correcta", weight: 1 }
        ]
      },
      {
        title: "De ganar, se convertiría en la primera mujer presidenta en la historia de Estados Unidos",
        options: [
          { text: "A) Harris", image: kamala, target: "correcta", weight: 1 },
          { text: "B) Trump", image: trump, target: "error", weight: 1 }
        ]
      },
      {
        title: "Es el primer candidato en la historia de Estados Unidos en haber sido procesado penalmente y fichado y actualmente enfrenta procesos penales ",
        options: [
          { text: "A) Harris", image: kamala, target: "error", weight: 1 },
          { text: "B) Trump", image: trump, target: "Correcta", weight: 1 }
        ]
      },
      {
        title: "Es dueño de un emporio, su esposa es modelo y ha sido cuestionado por haber aprovechado el sistema financiero para mejorar sus posibilidades de negocios",
        options: [
          { text: "A) Trump", image: trump, target: "Correcta", weight: 1  },
          { text: "B) Harris", image: kamala, target: "error", weight: 1 }
        ]
      },
      {
        title: "No tiene hijos, pero sí hijastros; tiene ascendencia india y jamaiquina",
        options: [
          { text: "A) Trump", image: trump, target: "error", weight: 1 },
          { text: "B) Harris", image: kamala, target: "correcta", weight: 1 }
        ]
      },
      {
        title: "Está a favor del derecho al aborto y de imponer restricciones a la venta y uso de armas",
        options: [
          { text: "A) Harris", image: kamala, target: "correcta", weight: 2},
          { text: "B) Trump", image: trump ,target: "error", weight: 2 }
        ]
      },
      {
        title: "Asegura que EU con él es más grande, que habría evitado la guerra entre Rusia y Ucrania, igual que la de Israel con Hamas; amenaza a la OTAN con no apoyar a los aliados y a México con aranceles",
        options: [
          { text: "A) Trump", image: trump, target: "correcta", weight: 1 },
          { text: "B) Harris", image: kamala, target: "error", weight: 1  }
        ]
      },
      {
        title: "Fue fiscal de California y también estuvo en el Senado",
        options: [
          { text: "A) Trump", image: trump, target: "error", weight: 2},
          { text: "B) Harris", image: kamala,target: "correcta", weight: 2 }
        ]
      },
      {
        title: "Presidente de EU que acusó fraude en su búsqueda por la reelección y bajo cuyo mandato hubo una irrupción en el Capitolio",
        options: [
          { text: "A) Trump", image: trump, target: "Correcta", weight: 1},
          { text: "B) Harris", image: kamala, target: "error", weight: 1 }
        ]
      },
    ];

    

    const currentQuestionData = questions[currentQuestion - 1];

    
    

    return (
      <div className="main-quiz">
  <div className="logotipo">
    <img src={logo} alt="El Universal" />
  </div>

  <div className="centrado">
    <div className="introduccion-res">
      <p className="pregunta">{currentQuestion}</p>
      <p className="titulo-pregunta">{currentQuestionData.title}</p>
    </div>

    <div className="main-fondo" style={{ backgroundImage: 'url("static/media/main-1920.d78a9de218ff4f8271f4.png")' }}>
      <div className="respuestas">
        {currentQuestionData.options.map((option, index) => (
          <div className="formato-respuesta" key={index} onClick={() => handleAnswer(option)}>
            <div className={option.target === "correcta" ? "fondo-imagen-republicano" : "fondo-imagen"}>
              <img src={option.image} alt={option.text} />
              <p>{option.text}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="div-barra">
        <div className="f-barra">
          <div className="b-progreso" style={{ width: `${(currentQuestion / questions.length) * 100}%` }}></div>
        </div>
      </div>
    </div>
  </div>
</div>

    );
  };

  const restartQuiz = () => {
    // Limpiar el localStorage
    localStorage.removeItem("quizAnswers");
    localStorage.removeItem("showHeader");
    // Redirigir a la ruta principal
    navigate('/'); 
  };
  
  return (
    <>
      {!quizCompleted && currentQuestion <= 10 ? (
        <div >
          {renderQuestion()}
        </div>
      ) : (
        <div>
          {showResults && (
            <div>
              {/* Mostrar resultados */}
              {calculateResult(answers)}
              {/* Botón para reiniciar */}
              <div className="boton-centro">
                <p className="repetir-quiz">¿Te gustaria intentarlo otra vez?</p>
                <button className="boton-quiz">
                  <div className="texto" onClick={restartQuiz}>¡Vuelve a tomar el quiz!</div>
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
  
};

Quiz.propTypes = {
  onQuizComplete: PropTypes.func.isRequired, // PropType para la función de devolución de llamada
};

export default Quiz;
